import { compressImage } from './images';

/**
 * Arquivos de comprovante — espelho de server/src/lib/files.ts. Aqui é só para
 * avisar antes de enviar; o servidor confere de novo, pelos bytes.
 */
export const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
export const ACCEPT_ATTRIBUTE = ACCEPTED_TYPES.join(',');
export const MAX_FILES = 5;
export const MAX_FILE_BYTES = 5 * 1024 * 1024;

/** Foto de perfil: só imagem — espelho de PHOTO_TYPES no servidor. */
export const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const PHOTO_ACCEPT_ATTRIBUTE = PHOTO_TYPES.join(',');

export const isImage = (type: string) => type.startsWith('image/');
const isAccepted = (type: string) => ACCEPTED_TYPES.includes(type);

/** 834 → "834 B"; 204800 → "200 KB"; 3,4 MB → "3,4 MB". */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}

/**
 * Filtra, comprime e confere os arquivos escolhidos. Devolve o que pode ser
 * enviado e, em português, o que ficou de fora e por quê.
 */
export async function prepareFiles(list: File[], room: number): Promise<{ files: File[]; problems: string[] }> {
  const problems: string[] = [];
  const accepted = list.filter((file) => isAccepted(file.type));
  if (accepted.length < list.length) problems.push('Só entram prints (JPEG, PNG ou WEBP) e PDFs.');
  if (accepted.length > room) problems.push(`Cabem no máximo ${MAX_FILES} arquivos por comprovante.`);

  const files: File[] = [];
  for (const original of accepted.slice(0, Math.max(0, room))) {
    const file = await compressImage(original);
    if (file.size > MAX_FILE_BYTES) {
      problems.push(`"${original.name}" passa de 5 MB mesmo depois de comprimido.`);
      continue;
    }
    files.push(file);
  }
  return { files, problems };
}
